module.exports = __webpack_public_path__ + "static/media/kids-wear02.1d363ae2.jpg";